import {createElement} from "./html";

/**
 * Create form-error element with {message}
 * @param {string} message
 * @return {HTMLDivElement}
 */
export function createFormError(message) {
    return createFormInfo(message, "form-info--error");
}

export function createFormInfo(message, className = "form-info") {
    return createElement(`<div class="${className}" style="opacity: 0; display: none;">
        <span class="form-info__message">
            ${message}
        </span>
    </div>`)
}

export function showFormInfo(element, message) {
    console.log("showFormInfo", element, message);
    element.style.opacity = 0;
    element.style.display = "block";

    if (message) {
        const messageEl = element.querySelector(".form-info__message");
        if (messageEl) messageEl.innerHTML = message;
    }


    requestAnimationFrame(() => {
        element.style.opacity = 1;
    });
}

export function hideFormInfo(element) {
    console.log("hideFormInfo", element);
    if (!element) return;
    element.style.opacity = 0;
    element.style.display = "none";
}


